import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalService } from '../../core/services/modal.service';

export interface IErrorModalOptions {
	title: string;
	text: string[];
	actions?: {
		type: 'solid' | 'text' | (string & {});
		text: string;
		callback?: (e: MouseEvent) => void;
	}[];
}

@Component({
	selector: 'app-new-error-modal',
	templateUrl: './new-error-modal.component.html',
	styleUrls: ['./new-error-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class NewErrorModalComponent {
	@Input() options: IErrorModalOptions;

	@Input() modalId;

	@Input() textList;

	constructor(
		private ms: ModalService,
	) { }

	close(id) {
		this.ms.close(id);
	}
}
